import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  saveAttribute,
  getListAttributes,
  getListValues,
  removeAttribute,
  removeValue,
  saveListValues,
} from '../../../../services/emailService';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import * as Icon from 'react-feather';
import CustomLoader from '../../../common/Loader';
import { Link } from 'react-router-dom';
import { Dialog, DialogTitle, DialogActions } from '@material-ui/core';
import { logActivity } from '../../../../services/utilService';
import AddEmailTemplate from './AddEmailTemplate';

class EmailSettings extends Component {
  state = {
    Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
    AddButtonName: '+ New Email Template',
    openAddTemplateDialog: false,
    toggleRender: false,
    emailTemplates: [],
    loading: false
  };

  constructor(props) {
    super(props);
    this.handleAddTemplateDialog = this.handleAddTemplateDialog.bind(this);
  }

  handleAddTemplateDialog() {
    this.setState({ toggleRender: !this.state.toggleRender })
    this.setState({ openAddTemplateDialog: true })
  }

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }

    let emailTemplates = this.state;

    return (
      <React.Fragment>
        <div className="float-right">
          <button className="btn btn-outline-blue rounded-0" onClick={this.handleAddTemplateDialog}>
            {this.state.AddButtonName}
          </button>
        </div>
        {/* Add new template */}
        <AddEmailTemplate key={this.state.toggleRender} Project_ID={this.props.Project_ID} openAddTemplateDialog={this.state.openAddTemplateDialog} />

        {/* Display list of existing templates */}
        {
          // emailTemplates.map((template, idx) => (
          //   <p>Hey</p>
          // ))
        }
      </React.Fragment>
    );
  }

}

export default EmailSettings;
